<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft> 
			
		 <b-col>
		<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller survey-list</h5>
				</b-col>				
			</b-row> -->
			<b-container fluid>
				<b-row class="mt-3 mb-2">
					
					<b-col class="text-right">
								 
						 <download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsCsv" name="survey.csv" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export CSV</download-csv>
					</b-col>
				</b-row>
			</b-container>
			<b-container fluid class="p-0 mt-2">
					
					<b-row class="m-0">
						<b-col class="col-md-12 col-sm-12 col-xs-12">
							<div class="container-box">
								<b-row class="mt-4 px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Show</span>
										<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
										</b-form-select>
										<span class="ml-2">entries</span>
									</b-col>
									<b-col lg="4" offset-md="2">
										<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
											<b-input-group size="sm">
												<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
												</b-form-input>
												<b-input-group-append>
													<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row class="px-3 pt-3">
									<b-col lg="12">
										<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
											
											
											
										
											<template v-slot:cell(fname)="row">
												<span v-if="JSON.parse(row.item.question).name!=''">
													
													{{JSON.parse(row.item.question).name}}
												</span>
												
											</template>
											<template v-slot:cell(email)="row">
												<span v-if="JSON.parse(row.item.question).email!=''">
													
													{{JSON.parse(row.item.question).email}}
												</span>
												
											</template>
											<template v-slot:cell(mobile)="row">
												<span v-if="JSON.parse(row.item.question).mobile!=''">
													
													{{JSON.parse(row.item.question).mobile}}
												</span>
												
											</template>
											<template v-slot:cell(q1)="row">
												<span v-if="JSON.parse(row.item.question).question01!=''">
													
													{{JSON.parse(row.item.question).question01}}
												</span>
												
											</template>
											<template v-slot:cell(q2)="row">
												{{JSON.parse(row.item.question).question02}}
											</template>
											<template v-slot:cell(q3)="row">
												<span v-if="JSON.parse(row.item.question).question03!=''">
													{{JSON.parse(row.item.question).question03==1?'Yes':'No'}}
												</span>
												
											</template>
											<template v-slot:cell(q4)="row">
												<span v-if="JSON.parse(row.item.question).question04!=''">
													{{JSON.parse(row.item.question).question04==1?'Yes':'No'}}
												</span>
											</template>
											<template v-slot:cell(q5)="row">
												
												{{JSON.parse(row.item.question).question05==1?'Yes':'No'}}
											</template>
											<template v-slot:cell(q6)="row">
												
												{{JSON.parse(row.item.question).question06==1?'Yes':'No'}}
											</template>
											<template v-slot:cell(q7)="row">
												{{JSON.parse(row.item.question).question07}}
											</template>
											<template v-slot:cell(q8)="row">
												{{JSON.parse(row.item.question).question08}}
											</template> 
											<template v-slot:cell(crerate_date)="row">
											{{$moment(row.value).format('DD-MM-YYYY')}}										
										</template>
										<template v-slot:cell(question)="row">
												<b-link @click="showSlectQue(row.item)" title="Resume">View</b-link>
										</template>
											
										</b-table>
									</b-col>
								</b-row>
								<b-row class="px-3">
									<b-col lg="6" class="text-left">
										<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
									</b-col>
									<b-col lg="3" offset-md="3">
										<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
					
					
				
			</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		<replayemail-popup :userData="selected" :subjectT="subjectT" fromEmail="careerslist"></replayemail-popup>
		<surveylist-popup :question="questionSelected" ></surveylist-popup>
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import Surveylistpopup from "@/components/surveylist-popup.vue";
import ReplayemailPopup from "@/components/admin/replayemail-popup.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"replayemail-popup": ReplayemailPopup,
		"surveylist-popup": Surveylistpopup,
		
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
            questionSelected: {},
			recordsCsv: [],
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'secureapi/getSurveysellerApplyList',
			selected:{},
			subjectT:'',
			//deleteUrl: this.$root.WEBAPI+'sellerapi/brand-delete',
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'fname', label: 'Name', 'extra': 1},
				{ key: 'email', label: 'Email', 'extra': 1 },
				{ key: 'mobile', label: 'Phone', 'extra': 1 },
				
				
				
				//{ key: 'status', label: 'Actions' },
				{ key: 'q1', label: 'Q1', 'extra': 1, class: 'text-center' },
				{ key: 'q2', label: 'Q2', 'extra': 1, class: 'text-center' },
				{ key: 'q3', label: 'Q3', 'extra': 1, class: 'text-center' },
				{ key: 'q4', label: 'Q4', 'extra': 1, class: 'text-center' },
				{ key: 'q5', label: 'Q5', 'extra': 1, class: 'text-center' },
				{ key: 'q6', label: 'Q6', 'extra': 1, class: 'text-center' },
				{ key: 'ipaddress', label: 'Ipaddress' },
				{ key: 'crerate_date', label: 'Post Date' },
				{ key: 'question', label: 'View' },
				/*{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }*/
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				about_brand: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:["","","",""]
			},
			emptyItem: {
				id: 0,
				brand_name: '',
				about_brand: '',
				brand_logo: '',
				gallery_images:[""],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.careersApplyList;
					//console.log(self.records);
					//self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;
					

					self.filteredCategory = [];
					//self.filterChildCategory(0, 0, 0);
					
					self.records.forEach(item => {
							var questionJson = JSON.parse(item.question);
							var postDate = self.$moment(item.crerate_date).format('DD-MM-YYYY');
							
							var Q3='';
							var Q4='';
							var Q5='';
							var Q6='';
							if(questionJson.question03!=''){
							Q3 = questionJson.question03==1?'Yes':'No';
							}if(questionJson.question04!=''){
							Q4 = questionJson.question04==1?'Yes':'No';
							}if(questionJson.question05!=''){
							Q5 = questionJson.question05==1?'Yes':'No';
							}
							if(questionJson.question06!=''){
							Q6 = questionJson.question06==1?'Yes':'No';
							}
							var fname =questionJson.name;
							var email =questionJson.email;
							var mobile =questionJson.mobile;
							
						var arrayCsv={'Name':fname,'Email':email,'Mobile':mobile,'Q1':questionJson.question01,'Q2':questionJson.question02,'Q3':Q3,'Q4':Q4,'Q5':Q5,'Q6':Q6,'Ip Address':item.ipaddress,'Post Date':postDate};					
						self.recordsCsv.push(arrayCsv);
					}); 	

					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		popoverMethod(obj){

			var resumeHtml=obj.question;
			
			/* var decoder = new TextDecoder('utf-8');

			var decodedMessage = decoder.decode(resumeHtml);*/
			
			return '<span>' + resumeHtml + '</span>'
		
		},showSlectQue(obj){
			this.questionSelected = JSON.parse(obj.question);
			this.$root.$emit('bv::show::modal', 'surveylistpopup');
		
		},
		replayEmail(item){
			var self = this;
			self.selected=item;
			self.subjectT=item.subject;
			self.$root.$emit('bv::show::modal', 'showShareEmailModal');
			
		}
	}
}
</script>
<style>
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1010;
  display: none;
  max-width: 600px;
  padding: 1px;
  text-align: left;
  white-space: normal;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 6px;
     -moz-border-radius: 6px;
          border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
     -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
     -moz-background-clip: padding;
          background-clip: padding-box;
}
</style>